<template>
  <el-form inline ref="queryForm" class="queryForm">
    <el-form-item v-for="(item,index) in queryData" :key="index">
      <template v-if="item.type == 'text'">
        <el-input v-model.trim="searchParams[item.paramName]" :placeholder="item.placeholder" @keyup.enter.native="search" maxlength="50" clearable></el-input>
      </template>
      <template v-if="item.type == 'select'">
        <el-select v-model="searchParams[item.paramName]" :placeholder="item.placeholder" clearable filterable>
          <el-option v-for="optionItem in item.options" :label="optionItem[item.optionKey.label]" :value="optionItem[item.optionKey.value]" :key="optionItem[item.optionKey.value]"></el-option>
        </el-select>
      </template>
      <template v-if="item.type == 'daterange'">
        <el-date-picker
          v-model="searchParams[item.paramName]"
          type="daterange"
          :start-placeholder="item.placeholder[0]"
          :end-placeholder="item.placeholder[1]"
          :format="item.format ? item.format : 'yyyy-MM-dd'"
          :value-format="item.valueFormat ? item.valueFormat : 'yyyy-MM-dd'">
        </el-date-picker>
      </template>
      <template v-if="item.type == 'month'">
        <el-date-picker
          v-model="searchParams[item.paramName]"
          type="month"
          :placeholder="item.placeholder ? item.placeholder : '选择月份'"
          :value-format="item.valueFormat ? item.valueFormat : 'yyyy-MM'">
        </el-date-picker>
      </template>
      <template v-if="item.type == 'date'">
        <el-date-picker
          v-model="searchParams[item.paramName]"
          type="date"
          :placeholder="item.placeholder ? item.placeholder : '选择日期'"
          :value-format="item.valueFormat ? item.valueFormat : 'yyyy-MM-dd'">
        </el-date-picker>
      </template>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="primary" @click="reset" plain>重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "bsp-query",
  props: {
    /**
     * data []
     *  {
     *      type: 'text',           // 文本框
     *      paramName: 'name',      // 参数名称 v-model
     *      placeholder: '订单号',
     *      defaultValue: ''        // 默认值
     *  },
     *  {
     *      type: 'select',         // 下拉框
     *      paramName: 'sendWay',   // 参数名称
     *      placeholder: '赠送方式',
     *      options: [{label: '',value: ''}], // 下拉选项
     *      optionKey:{ label: 'label', value: 'value' }, // 下拉选项绑定参数
     *      defaultValue: ''        // 默认值
     *  },
     *  {
     *      type: 'daterange',      // 日期
     *      paramName: 'auditTime', // 参数名称
     *      placeholder: ['开始审核日期', '结束审核日期'],
     *      format: '',             // 日期显示格式 默认 yyyy-MM-dd
     *      valueFormat: ''         // 日期格式 默认 yyyy-MM-dd,
     *      defaultValue: ''        // 默认值
     *  },
     *  {
     *      type: 'range',          // 区间值
     *      paramName: ['minCost', 'maxCost'],
     *      placeholder: ['最小金额', '最大金额'],
     *      rangeSeparator: '-'     // 默认为-
     *  }
     */
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      searchParams: {},
    }
  },
  methods: {
    // 点击查询
    search() {
      this.$emit('search', this.searchParams);
    },
    // 点击重置
    reset() {
      this.searchParams = {};
      this.$emit('search', this.searchParams);
    },
  },
  computed: {
    queryData() {
      let datas = this.data;
      datas.forEach(item => {
        if (item.defaultValue) {
          this.$set(this.searchParams, item.paramName, item.defaultValue);
        }
      })
      return datas;
    }
  }
}
</script>
<style lang="scss" scoped>
  .queryForm {
    .el-form-item {
      width: 217px;
      &:last-child {
        width: 150px;
      }
    }
    .el-form--inline .el-form-item__content {
      width: 100% !important;
    }
    .el-select, .el-date-editor, .el-range-editor, .el-input-number {
      width: 100% !important;
    }
  }
</style>
